module.exports = __webpack_public_path__ + "media/images/lease-c2466dfa3f639d800e9cd0a01cde786e.png";